<template>
    <v-col cols="12" sm="6" md="6" lg="8" xl="8">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-toolbar-title>
                    {{ widget.body.title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <vuetable
                    :fields="fieldDefinitions"
                    :api-mode="false"
                    :data="complaintTotals"
                    :css="table"
                    pagination-path=""
                    class="mytable"
                >
                    <template slot="tableHeader">
                        <template>
                            <tr>
                                <th />
                                <th v-for="(header, index) in uniquePeriodHeaders" :key="index" class="text-center" colspan="2">
                                    {{ header }}
                                </th>
                            </tr>
                        </template>
                        <vuetable-row-header />
                    </template>
                </vuetable>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import { findIndex } from 'lodash'
import Vuetable from 'vuetable-2'
import VuetableRowHeader from 'vuetable-2/src/components/VuetableRowHeader.vue'


export default {
    name: 'FourMonthsComplaintsReport',
    components: {
        Vuetable,
        VuetableRowHeader

    },
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            complaintTotals:[],
            uniquePeriodHeaders:[],
            fieldDefinitions:[
                {
                    name: 'type',
                    title: 'Typ reklamacji',
                    dataClass: 'text-no-wrap',
                }
            ],
            table: {
                tableWrapper: 'v-data-table v-data-table--dense',
                tableHeaderClass: '',
                tableBodyClass: '',
                tableClass: '',
            },
        }
    },
    created() {
        this.createHeaders()
        this.compileData()
    },
    methods: {
        createHeaders() {
            const periodHeaders = this.widget.body.content.map(item => item.period)

            this.uniquePeriodHeaders = periodHeaders.filter((item, idx) => periodHeaders.indexOf(item) === idx)
            this.uniquePeriodHeaders.forEach((element, idx) => {
                this.fieldDefinitions.push({
                    name: `period${idx + 1}_quantity`,
                    title: 'Ilość / uznane',
                    dataClass: 'text-no-wrap'
                })
                this.fieldDefinitions.push({
                    name: `period${idx + 1}_totalPrice`,
                    title: 'Kwota',
                    dataClass: 'text-no-wrap'
                })
            })
        },
        compileData() {
            this.widget.body.content.forEach(element => {
                const currentIndex = findIndex(this.complaintTotals, { 'type': element.type })

                if (currentIndex === -1) {
                    this.complaintTotals.push({
                        type: element.type,
                        period1_quantity: this.uniquePeriodHeaders.indexOf(element.period) === 0 ? `${element.totalQty}/${element.acceptedQty}` : '-',
                        period2_quantity: this.uniquePeriodHeaders.indexOf(element.period) === 1 ? `${element.totalQty}/${element.acceptedQty}` : '-',
                        period3_quantity: this.uniquePeriodHeaders.indexOf(element.period) === 2 ? `${element.totalQty}/${element.acceptedQty}` : '-',
                        period4_quantity: this.uniquePeriodHeaders.indexOf(element.period) === 3 ? `${element.totalQty}/${element.acceptedQty}` : '-',
                        period1_totalPrice: this.uniquePeriodHeaders.indexOf(element.period) === 0 ? `${element.acceptedTotalPrice}` : '-',
                        period2_totalPrice: this.uniquePeriodHeaders.indexOf(element.period) === 1 ? `${element.acceptedTotalPrice}` : '-',
                        period3_totalPrice: this.uniquePeriodHeaders.indexOf(element.period) === 2 ? `${element.acceptedTotalPrice}` : '-',
                        period4_totalPrice: this.uniquePeriodHeaders.indexOf(element.period) === 3 ? `${element.acceptedTotalPrice}` : '-',
                    })
                } else {
                    switch (this.uniquePeriodHeaders.indexOf(element.period)) {
                        case 0:
                            this.complaintTotals[currentIndex].period1_quantity = `${element.totalQty}/${element.acceptedQty}`
                            this.complaintTotals[currentIndex].period1_totalPrice = `${element.acceptedTotalPrice}`
                            break
                        case 1:
                            this.complaintTotals[currentIndex].period2_quantity = `${element.totalQty}/${element.acceptedQty}`
                            this.complaintTotals[currentIndex].period2_totalPrice = `${element.acceptedTotalPrice}`
                            break
                        case 2:
                            this.complaintTotals[currentIndex].period3_quantity = `${element.totalQty}/${element.acceptedQty}`
                            this.complaintTotals[currentIndex].period3_totalPrice = `${element.acceptedTotalPrice}`
                            break
                        case 3:
                            this.complaintTotals[currentIndex].period4_quantity = `${element.totalQty}/${element.acceptedQty}`
                            this.complaintTotals[currentIndex].period4_totalPrice = `${element.acceptedTotalPrice}`
                            break
                    }
                }
            })
        }
    }
}
</script>